import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
// import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

import Button from 'components/Core/Button/index';
import DataTable from 'components/DataTable/DataTableComponent';

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    width: 'fit-content'
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120
  },
  formControlLabel: {
    marginTop: theme.spacing(1)
  }
}));

const StyleGenerator = ({ parent }) => {
  parent.setState({ classes: useStyles(), mountResizer: true, isStyleGenerated: true }, () => {
    let finderBody = (
      <DataTable module={parent.module} tableConfig={parent.finderConfig} dataSourceConfig={parent.dataSourceConfig} />
    );

    parent.setState({
      finderBody,
      onMsgDialogOKClick: parent.closeMessageDialog,
      onMsgDialogCancelClick: parent.closeMessageDialog
    });
  });

  return <> </>;
}

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default class Finder extends React.Component {
  constructor(props) {
    super(props);

    const { parent, module, finderTitle, finderConfig, dataSourceConfig, additionalDataModel } = this.props;

    this.parent = parent;
    this.module = module;
    this.finderTitle = <div style={{ flex: 24 }}>{finderTitle ? finderTitle : parent.baseComponent.current.commonNotifications['msgDialogHeader']}</div>;

    this.finderConfig = finderConfig;
    if (this.finderConfig.onRowDoubleClick) {
      this._onRowDoubleClick = this.finderConfig.onRowDoubleClick.bind(null);
    }

    this.dataSourceConfig = dataSourceConfig;
    this.additionalDataModel = additionalDataModel;

    this.state = {
      maxWidth: this.props.maxWidth ? this.props.maxWidth : 'md',
      mountResizer: false
    }
  }

  componentDidMount() {
    if (!this.finderConfig.onRowDoubleClick) {
      this.onRowDoubleClick = (event) => {
        const rowData = event.data;

        this.parent.baseComponent.current.load(
          this.parent,
          this.dataSourceConfig.modelLoaderController ? this.dataSourceConfig.modelLoaderController : this.dataSourceConfig.controller,
          `${this.dataSourceConfig.modelLoader}/${rowData[this.parent.state.keyProp]}`,
          {},
          // {
          //   [this.parent.state.keyProp]: rowData[this.parent.state.keyProp]
          // },
          this.additionalDataModel, this.finderConfig.beforeLoad, this.finderConfig.afterLoad, this);
      }
    } else {
      this.onRowDoubleClick = (event) => {
        if (this.dataSourceConfig.extraData) {
          this._onRowDoubleClick(event, this.dataSourceConfig.extraData);
        } else {
          this._onRowDoubleClick(event);
        }
      }
    }

    this.onRowSelect = (event) => {
      this.setState({
        onMsgDialogOKClick: this.onRowDoubleClick.bind(
          null,
          event
        )
      });
    }

    this.finderConfig.onRowDoubleClick = this.onRowDoubleClick;
    this.finderConfig.onRowSelect = this.onRowSelect;

    this.closeMessageDialog = () => {
      this.parent.baseComponent.current.setState({ showFinder: false });
    }

    this.handleMaxWidthChange = event => {
      this.setState({ maxWidth: event.target.value });
    };
  }

  render() {
    return (
      <Dialog open maxWidth={this.state.maxWidth} PaperComponent={PaperComponent}>
        <DialogTitle>
          {
            this.state.mountResizer &&
            <form className={this.state.classes.form} noValidate>
              <div style={{ display: 'flex' }}>
                {this.finderTitle}
                {/* <div style={{ flex: 15 }}>
                  <span style={{ marginRight: '10px' }}>Size:</span>
                  <FormControl className={this.state.classes.formControl}>
                    <Select
                      //autoFocus                      
                      value={this.state.maxWidth}
                      onChange={this.handleMaxWidthChange}
                      disableUnderline>
                      <MenuItem value={false}>false</MenuItem>
                      <MenuItem value="xs">xs</MenuItem>
                      <MenuItem value="sm">sm</MenuItem>
                      <MenuItem value="md">md</MenuItem>
                      <MenuItem value="lg">lg</MenuItem>
                      <MenuItem value="xl">xl</MenuItem>
                    </Select>
                  </FormControl>
                </div> */}
                <div style={{ flex: 1, margin: '-15px -23px 0 0' }}>
                  <IconButton onClick={this.state.onMsgDialogCancelClick}>
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            </form>
          }
        </DialogTitle>
        <DialogContent>
          {
            this.state.isStyleGenerated &&
            this.state.finderBody
          }

          {
            !this.state.isStyleGenerated && <StyleGenerator parent={this} />
          }
          <DialogActions style={{ paddingTop: '31px', marginRight: '-24px' }}>
            <Button label={this.parent.baseComponent.current.commonLabels['buttonCancel']} style={{ margin: '0 15px 10px 0' }} onClick={this.state.onMsgDialogCancelClick}></Button>
            <Button label={this.parent.baseComponent.current.commonLabels['buttonOK']} style={{ margin: '0 20px 10px 0', minWidth: '60px' }} onClick={this.state.onMsgDialogOKClick}></Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    );
  }
};
